<div class="jobs" id="jobs">
  <div class="container">
    <div class="jobs__box row">
      <h2 class="jobs__title col-12">Nice Jobs</h2>
      <div class="jobs__section row">
        @if (jobOffers.length > 0) { @for (job of jobOffers; track job) {
        <div class="jobs__card row flex-column flex-xl-row">
          <div class="jobs__card-info col-12 col-xl-9 p-0 d-flex flex-column">
            <div class="jobs__card-top d-flex flex-column flex-xl-row">
              <p class="jobs__card-title display display-2b">
                {{ job.title }}
              </p>
              <div>
                <ul class="jobs__card-list d-flex">
                  @for (tag of job.tags; track tag) {
                  <li class="jobs__card-list-item">
                    <p class="m-0 display display-tags">
                      {{ tag }}
                    </p>
                  </li>
                  }
                </ul>
              </div>
            </div>
            <div class="jobs__card-details d-flex flex-column flex-xl-row">
              <div class="jobs__card-details-item">
                <img
                  class="jobs__card-details-img"
                  src="../../../../assets/job/Finance_Business.svg"
                  alt="Finance Business"
                />
                <p class="jobs__card-details-text _1r m-0">
                  {{ job.salary }}
                </p>
              </div>
              <div class="jobs__card-details-item">
                <img
                  class="jobs__card-details-img"
                  src="../../../../assets/job/location.svg"
                  alt="Location"
                />
                <p class="jobs__card-details-text _1r m-0">
                  {{ job.localization }}
                </p>
              </div>
              <div class="jobs__card-details-item">
                <img
                  class="jobs__card-details-img"
                  src="../../../../assets/job/contract.svg"
                  alt="Contract"
                />
                <p class="jobs__card-details-text _1r m-0">
                  {{ job.detailsContract }}
                </p>
              </div>
            </div>
          </div>
          <a
            [routerLink]="['/careers', job.id]"
            class="jobs__card-details-btn btn btn-secondary col-12 offset-xl-1 col-xl-2"
            type="button"
          >
            See more
          </a>
        </div>
        } } @else {
        <div class="jobs__note col-12">
          <h3 class="mb-3">Sorry! We are not currently recruiting</h3>
          <p class="_1r m-0">
            If you would like to contact us please do so via the contact form
            below.
          </p>
        </div>
        }
      </div>
    </div>
  </div>
</div>
